export interface PomMasterEntry {
  code: number;
  name: string;
  tolerance: number;
}

export const POM_MASTER: PomMasterEntry[] = [
  { code: 1, name: "Front Length", tolerance: 0.5 },
  { code: 2, name: "Center Front Length", tolerance: 0.5 },
  { code: 3, name: "Center Back Length", tolerance: 0.5 },
  { code: 4, name: "Side Length", tolerance: 0.25 },
  { code: 5, name: "FT Bodice Length", tolerance: 0.25 },
  { code: 6, name: "CF Bodice Length", tolerance: 0.25 },
  { code: 7, name: "CB Bodice Length", tolerance: 0.25 },
  { code: 8, name: "SS Bodice Length", tolerance: 0.25 },
  { code: 9, name: "Chest Width", tolerance: 0.375 },
  { code: 10, name: "Chest Width Circ.", tolerance: 0.75 },
  { code: 11, name: "Chest Width (Rag.)", tolerance: 0.375 },
  { code: 12, name: "Chest Width Circ. (Rag.)", tolerance: 0.75 },
  { code: 13, name: "Across Shoulder", tolerance: 0.25 },
  { code: 14, name: "Shoulder Width", tolerance: 0.25 },
  { code: 15, name: "Across Chest", tolerance: 0.25 },
  { code: 16, name: "Across Back", tolerance: 0.25 },
  { code: 17, name: "Across Chest Mid Arm.", tolerance: 0.25 },
  { code: 18, name: "Across Back Mid Arm.", tolerance: 0.25 },
  { code: 19, name: "Armhole Depth", tolerance: 0.25 },
  { code: 20, name: "Sleeve Length", tolerance: 0.5 },
  { code: 21, name: "Sleeve Length from CB", tolerance: 0.5 },
  { code: 22, name: "Sleeve Length from HPS", tolerance: 0.5 },
  { code: 23, name: "Underarm Seam Length", tolerance: 0.25 },
  { code: 24, name: "Upper Arm Width", tolerance: 0.25 },
  { code: 25, name: "Elbow Width", tolerance: 0.25 },
  { code: 26, name: "Wrist Width", tolerance: 0.25 },
  { code: 27, name: "Cuff Width", tolerance: 0.25 },
  { code: 28, name: "Neck Width", tolerance: 0.25 },
  { code: 29, name: "Neck Drop Front", tolerance: 0.25 },
  { code: 30, name: "Neck Drop Back", tolerance: 0.25 },
  { code: 31, name: "Collar Height", tolerance: 0.125 },
  { code: 32, name: "Collar Stand Height", tolerance: 0.125 },
  { code: 33, name: "Lapel Width", tolerance: 0.125 },
  { code: 34, name: "Waist Width", tolerance: 0.375 },
  { code: 35, name: "Waist Width Circ.", tolerance: 0.75 },
  { code: 36, name: "Hip Width", tolerance: 0.375 },
  { code: 37, name: "Hip Width Circ.", tolerance: 0.75 },
  { code: 38, name: "Thigh Width", tolerance: 0.375 },
  { code: 39, name: "Knee Width", tolerance: 0.25 },
  { code: 40, name: "Leg Opening", tolerance: 0.25 },
  { code: 41, name: "Inseam Length", tolerance: 0.5 },
  { code: 42, name: "Outseam Length", tolerance: 0.5 },
  { code: 43, name: "Rise (Front)", tolerance: 0.25 },
  { code: 44, name: "Rise (Back)", tolerance: 0.25 },
  { code: 45, name: "Waistband Width", tolerance: 0.125 },
  { code: 100, name: "Pocket Width", tolerance: 0.25 },
  { code: 101, name: "Pocket Depth", tolerance: 0.25 },
  { code: 102, name: "Pocket Placement from CF", tolerance: 0.25 },
  { code: 103, name: "Pocket Placement from Waist", tolerance: 0.25 },
  { code: 158, name: "Twill Tie", tolerance: 0 },
  { code: 159, name: "Tie Length", tolerance: 0.5 },
  { code: 160, name: "Tie Width", tolerance: 0.25 },
  { code: 200, name: "Total Garment Length", tolerance: 0.5 },
  { code: 201, name: "Vent Length", tolerance: 0.25 },
  { code: 202, name: "Back Yoke Width", tolerance: 0.25 },
  { code: 203, name: "Fly Length", tolerance: 0.25 },
  { code: 204, name: "Belt Loop Width", tolerance: 0.125 },
  { code: 205, name: "Belt Loop Length", tolerance: 0.125 },
];
